<div *ngIf="!isDashboardProjection" class="h-100 mr-3">
    <a *ngIf="shouldRender()" href="{{getPopoutUrl()}}" target="_blank">
        <svg class="popout-btn fill-iconDefault">
            <use href="../App_Themes/CXone/icons/new-window.svg#new-window"></use>
        </svg>
    </a>
</div>
